import {
  Card,
  Typography,
  Stack,
  useTheme,
} from '@mui/material';
import React from 'react';
import contactData from '../../constants/faq/contact-info';
import InformationStack from '../../components/stacks/InformationStack';
import useContactInformation from '../../hooks/useContactInformation';
import HelpCenterForm from '../../components/forms/HelpCenterForm';
import {
  STACK_CENTER_COLUMN_DIRECTION,
  INFORMATION_STACK_WITH_BORDER,
  STACK_START_COLUMN_DIRECTION,
} from '../../constants/mui-components';
import {
  cardContainer,
  containerStack,
  titleTypography,
  infoItemStack,
  infoTitleTypography,
  infoDescriptionTypography,
} from './styles/contact-form-styles';

function ContactForm() {
  const theme = useTheme();
  const contactInfo = useContactInformation();
  const contactFormData = contactData(contactInfo);

  return (
    <>
      <Stack className={STACK_CENTER_COLUMN_DIRECTION} sx={containerStack(theme)}>
        <Stack className={STACK_CENTER_COLUMN_DIRECTION} gap="1rem">
          <InformationStack
            className={INFORMATION_STACK_WITH_BORDER}
            text={contactFormData.stackText}
            backgroundColor={theme.palette.neutral.A700}
            textColor="white"
            variant="info_stack"
            fontWeight={800}
          />
          <Typography variant="xlarge_2" sx={titleTypography}>
            {contactFormData.titleText}
          </Typography>
          <Typography variant="medium_1" color="white">
            {contactFormData.subtitleText}
          </Typography>
        </Stack>
        <Card sx={cardContainer}>
          <Stack className={STACK_START_COLUMN_DIRECTION} gap="1.625rem">
            <Stack sx={infoItemStack}>
              <Typography variant="large_1" sx={infoTitleTypography(theme)}>
                {contactFormData.title}
              </Typography>
              <Typography variant="small_3" sx={infoDescriptionTypography(theme)}>
                {contactFormData.description}
              </Typography>
            </Stack>
            {contactFormData.contactInfo.map((info) => (
              <Stack key={info.title} sx={infoItemStack}>
                <Typography variant="medium_2" sx={infoTitleTypography(theme)}>
                  {info.title}
                </Typography>
                <Typography variant="small_3" sx={infoDescriptionTypography(theme)}>
                  {info.description}
                </Typography>
              </Stack>
            ))}
          </Stack>
          <HelpCenterForm
            nameLabel={contactFormData.contactNameLabel}
            phoneNumberLabel={contactFormData.contactPhoneLabel}
            emailLabel={contactFormData.contactEmailLabel}
            questionLabel={contactFormData.contactQuestionLabel}
            buttonText={contactFormData.buttonText}
            maxWidth="33rem"
          />
        </Card>
      </Stack>
    </>
  );
}

export default ContactForm;
